import type { ReactNode } from 'react';
import { Outlet } from 'react-router-dom';

import { PageShell } from '~/components/layout';
import { NoPermission } from '~/components/ui';
import { getAccess } from '~/modules/access';
import type { Guard } from '~/app/access';

/** Renders the route's children (or its `Outlet`) when `allow` passes, else the refusal in place (DESIGN.md §11.3). Never redirects. */
export function RequireAccess({ allow, resource, children }: Guard & { children?: ReactNode }) {
  const access = (() => {
    try {
      return getAccess();
    } catch {
      return null;
    }
  })();

  if (!access || !allow(access)) {
    return (
      <PageShell>
        <NoPermission resource={resource} />
      </PageShell>
    );
  }

  return children ?? <Outlet />;
}
